import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { buildProcessingFactoryWritePayload } from '#/api/momMgmt/settings/processingFactory/serializeProcessingFactoryWrite';

export async function updateProcessingFactory(id, values) {
  const updatedAt = values?.updatedAt ?? values?.record?.updatedAt ?? null;
  const { data: raw } = await request.patch(
    `/mom/processing-factory/${id}`,
    keysToSnake(buildProcessingFactoryWritePayload(values, { updatedAt })),
  );
  return parseVer4DetailResponse(raw);
}
